import { BaseComunicationProvider } from './basecomunication';
import { Injectable } from '@angular/core';
import { AboutResult } from '../entities/aboutResult';

@Injectable()
export class AboutService extends BaseComunicationProvider {
    public address: string = "AboutHandler.ashx"; 

    about() {
        return new Promise((resolve, reject) => {
            this.sendDataHttp("About", JSON.stringify(""))
              .then(data => {
                var json: any = data;
                resolve(json.Item);
              }).catch((err) => {
                  reject(err);
              });
            })
    };

    about2() {
        return new Promise((resolve, reject) => {
            this.sendDataHttp("About2", JSON.stringify(""))
              .then(data => {
                var json: any = data;
                resolve(<AboutResult>json.Item);
              }).catch((err) => {
                  reject(err);
              });
            })
    };

    about3() {
        return new Promise((resolve, reject) => {
            this.sendDataHttp("About3", JSON.stringify(""))
              .then(data => {
                var json: any = data;
                resolve(json.Item);
              }).catch((err) => {
                  reject(err);
              });
            })
    };
}


// WEBPACK FOOTER //
// ./src/providers/about.ts